import { ReactNode } from 'react'
import styles from './LayoutWithHeaderAndFooter.module.scss'

const LayoutWithHeaderAndFooter = ({ children }: { children: ReactNode }) => (
  <div className={styles.layout}>{children}</div>
)

export default LayoutWithHeaderAndFooter
